import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ToggleColorMode from "./ToggleColorMode";
import logos from "../assets/logos.png";

import Menu from "@mui/material/Menu";
import Grid from "@mui/material/Grid";
import Collapse from "@mui/material/Collapse";
import { useNavigate } from "react-router-dom";

const logoStyle = {
  width: "80px",
  height: "auto",
  cursor: "pointer",
};

function AppAppBar({ mode, toggleColorMode }) {
  const navigate = useNavigate();

  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [mobileDropdownOpen, setMobileDropdownOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
  };

  const handleMenuClick = (event) => {
    setMenuAnchorEl(menuAnchorEl ? null : event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleNavigation = (path) => {
    handleMenuClose();
    navigate(path);
    setDrawerOpen(false);
    setMenuAnchorEl(null);
  };

  const toggleMobileDropdown = () => {
    setMobileDropdownOpen(!mobileDropdownOpen);
  };

  const isMenuOpen = Boolean(menuAnchorEl);

  const scrollToSection = (sectionId) => {
    navigate("/");
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: "smooth" });
      window.scrollTo({
        top: targetScroll,
        behavior: "smooth",
      });
      setDrawerOpen(false);
    }
  };

  return (
    <div>
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          bgcolor: "transparent",
          backgroundImage: "none",
          mt: 2,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            variant="regular"
            sx={(theme) => ({
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexShrink: 0,
              borderRadius: "999px",
              bgcolor:
                theme.palette.mode === "light"
                  ? "rgba(255, 255, 255, 0.4)"
                  : "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(24px)",
              maxHeight: 40,
              border: "1px solid",
              borderColor: "divider",
              boxShadow:
                theme.palette.mode === "light"
                  ? `0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)`
                  : "0 0 1px rgba(2, 31, 59, 0.7), 1px 1.5px 2px -1px rgba(2, 31, 59, 0.65), 4px 4px 12px -2.5px rgba(2, 31, 59, 0.65)",
            })}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                alignItems: "center",
                ml: "-18px",
                px: 1,
              }}
            >
              <img
                src={logos}
                style={logoStyle}
                alt="logo of sitemark"
                onClick={() => handleNavigation("/")}
              />
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <MenuItem
                  onClick={() => scrollToSection("hero")}
                  sx={{ py: "6px", px: "12px", cursor: "pointer" }}
                >
                    <Typography variant="body2" color="text.primary">
                      Home
                    </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => scrollToSection("about")}
                  sx={{ py: "6px", px: "12px", cursor: "pointer" }}
                >
                  <Typography variant="body2" color="text.primary">
                    About us
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => scrollToSection("highlights")}
                  sx={{ py: "6px", px: "12px", cursor: "pointer" }}
                >
                  <Typography variant="body2" color="text.primary">
                    Services
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={handleMenuClick}
                  sx={{
                    py: "6px",
                    px: "12px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="body2" color="text.primary">
                    Legal Services
                  </Typography>
                  <ArrowDropDownIcon />
                </MenuItem>
                <Menu
                  anchorEl={menuAnchorEl}
                  open={isMenuOpen}
                  onClose={handleMenuClose}
                  PaperProps={{
                    sx: { width: 600 },
                  }}
                >
                  <Box sx={{ p: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <Typography pl={2} variant="subtitle1">
                          TradeMark
                        </Typography>
                        <MenuItem
                          onClick={() => handleNavigation("/opposition")}
                        >
                          TradeMark Opposition
                        </MenuItem>
                        <MenuItem onClick={() => handleNavigation("/renewal")}>
                          TradeMark Renewal
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleNavigation("/registration")}
                        >
                          TradeMark Registration
                        </MenuItem>
                        <MenuItem onClick={() => handleNavigation("/watch")}>
                          TradeMark Watch
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleNavigation("/objection")}
                        >
                          TradeMark Objection
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleNavigation("/assignment")}
                        >
                          TradeMark Assignment
                        </MenuItem>
                        <MenuItem onClick={() => handleNavigation("/search")}>
                          TradeMark Search
                        </MenuItem>
                      </Grid>

                      <Grid item xs={4}>
                        <Typography pl={2} variant="subtitle1">
                          Patent
                        </Typography>
                        <MenuItem
                          onClick={() =>
                            handleNavigation("/patentRegistration")
                          }
                        >
                          Patent Registration
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleNavigation("/patentProvisional")}
                        >
                          Patent Provisional
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleNavigation("/patentSearch")}
                        >
                          Patent Search
                        </MenuItem>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography pl={2} variant="subtitle1">
                          CopyRight
                        </Typography>
                        <MenuItem
                          onClick={() =>
                            handleNavigation("/copyrightRegistration")
                          }
                        >
                          CopyRight Registration
                        </MenuItem>

                        <Typography pl={2} mt={2} variant="subtitle1">
                          Design
                        </Typography>
                        <MenuItem
                          onClick={() =>
                            handleNavigation("/designRegistration")
                          }
                        >
                          Design Registration
                        </MenuItem>
                        <MenuItem
                          onClick={() =>
                            handleNavigation("/designObjectionReply")
                          }
                        >
                          Design Objection Reply
                        </MenuItem>
                        <MenuItem
                          onClick={() =>
                            handleNavigation("/designDepartmentHearing")
                          }
                        >
                          Design Department Hearing
                        </MenuItem>
                      </Grid>
                    </Grid>
                  </Box>
                </Menu>
                {/* <MenuItem
                  onClick={() => scrollToSection("pricing")}
                  sx={{ py: "6px", px: "12px", cursor: "pointer" }}
                >
                  <Typography variant="body2" color="text.primary">
                    Pricing
                  </Typography>
                </MenuItem> */}
                <MenuItem
                  onClick={() => scrollToSection("faq")}
                  sx={{ py: "6px", px: "12px", cursor: "pointer" }}
                >
                  <Typography variant="body2" color="text.primary">
                    FAQ
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => scrollToSection("map")}
                  sx={{ py: "6px", px: "12px", cursor: "pointer" }}
                >
                  <Typography variant="body2" color="text.primary">
                    Our Location
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => scrollToSection("query-form")}
                  sx={{ py: "6px", px: "12px", cursor: "pointer" }}
                >
                  <Typography variant="body2" color="text.primary">
                    Query
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => scrollToSection("footer")}
                  sx={{ py: "6px", px: "12px", cursor: "pointer" }}
                >
                  <Typography variant="body2" color="text.primary">
                    Contact us
                  </Typography>
                </MenuItem>
              </Box>
            </Box>
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                gap: 0.5,
                alignItems: "center",
              }}
            >
              <ToggleColorMode mode={mode} toggleColorMode={toggleColorMode} />
            </Box>
            <Box sx={{ display: { sm: "", md: "none" } }}>
              <Button
                variant="text"
                color="primary"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ minWidth: "30px", p: "4px" }}
              >
                <MenuIcon />
              </Button>
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
              >
                <Box
                  sx={{
                    minWidth: "60dvw",
                    p: 2,
                    backgroundColor: "background.paper",
                    flexGrow: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "end",
                      flexGrow: 1,
                    }}
                  >
                    <ToggleColorMode
                      mode={mode}
                      toggleColorMode={toggleColorMode}
                    />
                  </Box>
                  <MenuItem onClick={() => scrollToSection("hero")}>
                    Home
                  </MenuItem>
                  <MenuItem onClick={() => scrollToSection("about")}>
                    About us
                  </MenuItem>
                  <MenuItem onClick={() => scrollToSection("highlights")}>
                    Services
                  </MenuItem>
                  <MenuItem
                    onClick={toggleMobileDropdown}
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="body2"> Legal Services </Typography>
                    <ArrowDropDownIcon />
                  </MenuItem>
                  <Collapse in={mobileDropdownOpen}>
                    <Box sx={{ pl: 4 }}>
                      <Typography variant="subtitle1">TradeMark</Typography>
                      <MenuItem onClick={() => handleNavigation("/opposition")}>
                        Opposition
                      </MenuItem>
                      <MenuItem onClick={() => handleNavigation("/renewal")}>
                        Renewal
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleNavigation("/registration")}
                      >
                        Registration
                      </MenuItem>
                      <MenuItem onClick={() => handleNavigation("/watch")}>
                        Watch
                      </MenuItem>
                      <MenuItem onClick={() => handleNavigation("/objection")}>
                        Objection
                      </MenuItem>
                      <MenuItem onClick={() => handleNavigation("/assignment")}>
                        Assignment
                      </MenuItem>
                      <MenuItem onClick={() => handleNavigation("/search")}>
                        Search
                      </MenuItem>
                      <Typography variant="subtitle1">Patent</Typography>
                      <MenuItem
                        onClick={() => handleNavigation("/patentRegistration")}
                      >
                        Patent Registration
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleNavigation("/patentProvisional")}
                      >
                        Patent Provisional
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleNavigation("/patentSearch")}
                      >
                        Patent Search
                      </MenuItem>
                      <Typography variant="subtitle1">CopyRight</Typography>
                      <MenuItem
                        onClick={() =>
                          handleNavigation("/copyrightRegistration")
                        }
                      >
                        CopyRight Registration
                      </MenuItem>
                      <Typography variant="subtitle1">Design</Typography>
                      <MenuItem
                        onClick={() => handleNavigation("/designRegistration")}
                      >
                        Design Registration
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          handleNavigation("/designObjectionReply")
                        }
                      >
                        Design Objection Reply
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          handleNavigation("/designDepartmentHearing")
                        }
                      >
                        Design Department Hearing
                      </MenuItem>
                    </Box>
                  </Collapse>
                  {/* <MenuItem onClick={() => scrollToSection("pricing")}>
                    Pricing
                  </MenuItem> */}
                  <MenuItem onClick={() => scrollToSection("faq")}>
                    FAQ
                  </MenuItem>
                  <MenuItem onClick={() => scrollToSection("map")}>
                    Our Location
                  </MenuItem>
                  <MenuItem onClick={() => scrollToSection("query-form")}>
                    Query
                  </MenuItem>
                  <MenuItem onClick={() => scrollToSection("footer")}>
                    Contact us
                  </MenuItem>
                  <Divider />
                </Box>
              </Drawer>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}

AppAppBar.propTypes = {
  mode: PropTypes.oneOf(["dark", "light"]).isRequired,
  toggleColorMode: PropTypes.func.isRequired,
};

export default AppAppBar;
